import React from "react";
import { Box, Button } from "@mui/material";
import WhatWeDo from "../../components/OurNetwork/WhatWeDo";
import GlobalHeroCard from "../../components/GlobalHeroCard";
import { useNavigate } from "react-router-dom";

const Network = () => {
  const navigate = useNavigate();

  return (
    <Box style={{ flex: 1, marginTop: 100 }}>
      <Box>
        <GlobalHeroCard />
      </Box>

      <Box>
        <WhatWeDo />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 0,
          mb: 5,
        }}
      >
        <Button
          onClick={() => navigate("/contact")}
          sx={{
            color: "white",
            fontWeight: 600,
            fontSize: "13px",
            borderRadius: "30px",
            textTransform: "none",
            fontFamily: '"Poppins", serif',
            padding: "8px 15px",
            transition: "all 0.3s ease-in-out",
            background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
            "&:hover": {
              background: "linear-gradient(93.14deg, #63B8FF, #1E90FF)",
              color: "#fff",
            },
            "@media (max-width: 600px)": {
              fontSize: "13px",
              // padding: "10px 18px",
            },
          }}
        >
          Become a Partner
        </Button>
      </Box>
    </Box>
  );
};

export default Network;
